import SearchPage from "./searchPage";

export default class ActivePage extends SearchPage  {

    constructor() {
        super();

        this.recordNavigator = null;
        this.infoContainer = null;
        this.detailMainButtons = null;
        this.mainDetailContainer = "";
        this.detailContentContainer = "";
        this.currentRecordId = 0;
        this.detailUrl = "";
        this.editableGrids = [];
        this.deleteForm = "";
        this.recordStampsUrl = "";
        this.recordStampsContainer = "";
        this.entryFormInstance = null;
       
        this.showDetails = this.showDetails.bind(this);
        this.afterInsert = this.afterInsert.bind(this);
        this.doneAdding = this.doneAdding.bind(this);
        this.afterCancelledInsert = this.afterCancelledInsert.bind(this);
        this.updateRecordStamps = this.updateRecordStamps.bind(this);
        //this.searchPage = searchPage;

        //if (!this.searchPage) {
        //    this.searchPage = new SearchPage();
        //}
    }

    //if we need to support searchpage to be injected
    /* search functions */
    //initializeSearchPage(searchPage) {
    //    this.searchPage.initializeSearchPage(searchPage);
    //}

    //initializeSearchResultPage(searchResultPage) {
    //    this.searchPage.initializeSearchResultPage(searchResultPage);
    //}

    //gridMainSearchFilters = (e) => {
    //    return this.searchPage.gridMainSearchFilters(e);
    //}

    //searchResultGridRequestEnd = (e) => {
    //    this.searchPage.searchResultGridRequestEnd(e);
    //}

    //searchResultGridError = (e) => {
    //    this.searchPage.searchResultGridError(e);
    //}

    //get searchUrl() {
    //    return this.searchPage.searchUrl;
    //}
    //set searchUrl(url) {
    //    this.searchPage.searchUrl = url; 
    //}

    //get searchContainer() {
    //    return this.searchPage.searchContainer;
    //}
    //set searchContainer(searchContainer) {
    //    this.searchPage.searchContainer = searchContainer;
    //}

    //get searchResultGrid() {
    //    return this.searchPage.searchResultGrid;
    //}
    //set searchResultGrid(grid) {
    //    this.searchPage.searchResultGrid = grid;
    //}

    //get mainSearchRecordIds() {
    //    return this.searchPage.mainSearchRecordIds;
    //}
    //set mainSearchRecordIds(ids) {
    //    this.searchPage.mainSearchRecordIds = ids;
    //}

    /* detail functions */
    //initializes breadcrumbs, record navigator, record details container and urls
    initializeDetailPage(detailPage) {
        this.detailUrl = detailPage.detailUrl;
        this.searchUrl = detailPage.searchUrl;
        this.mainDetailContainer = detailPage.mainDetailContainer;
        this.detailContentContainer = detailPage.detailContentContainer;

        window.cpiBreadCrumbs.addNode({
            name: detailPage.mainDetailContainer,
            label: detailPage.title,
            url: detailPage.detailUrl,
            refresh: false,
            updateHistory: true
        });

        $(() => {
            this.initializeInfoContainer();
            this.recordNavigator = $(`#${detailPage.recordNavigatorContainer}`);

            //setup record navigator 
            if (this.recordNavigator) {
                if (detailPage.singleRecord) {
                    this.mainSearchRecordIds = []; //clear existing
                    this.mainSearchRecordIds.push(detailPage.recordId);
                }

                this.recordNavigator.cpiRecordNavigator({
                    recordIds: this.mainSearchRecordIds,
                    currentId: detailPage.recordId,
                    navigateHandler: detailPage.recordNavigateHandler
                        ? detailPage.recordNavigateHandler
                        : this.showDetails
                });
            };
            $(this.infoContainer).on("click", ".k-grid .details-link", function (e) {
                e.preventDefault();
                const link = $(this);

                if (link.attr("target") === "_blank") {
                    window.open(link.attr("href"), "_blank");
                }
                else
                  pageHelper.openDetailsLink(link);
            });
        });

        

        pageHelper.moveBreadcrumbs(`#${detailPage.mainDetailContainer}`);
    }

    initializeInfoContainer() {
        this.infoContainer = $("#" + this.detailContentContainer);
        const initialActiveTab = "MainInfo";
        const container = this.infoContainer.find(".tab-content");
        if (container) {
            container.data("activeTab", initialActiveTab);
        }
    }

    initializeDetailContentPage(detailContentPage) {
        const options = detailContentPage;
        this.recordStampsUrl = options.recordStampsUrl;
        this.recordStampsContainer = options.recordStampsContainer;
        this.deleteForm = options.deleteForm;
        options.activePage = this;

        pageHelper.manageDetailPage(options);

       window.cpiBreadCrumbs.updateLastNode({
            name: this.mainDetailContainer,
            label: detailContentPage.title,
            url: detailContentPage.detailUrl,
            refresh: true,
            //todo: refresh details unless in addMode
            //refreshHandler: refreshDetails,
            updateHistory: true
        });

        pageHelper.initializeDetailTabs(this);
        $(`#${this.detailContentContainer}`).floatLabels();
    }

    showDetails(id) {
        return pageHelper.showDetails(this, id);
    }

    cancelAddFromOtherScreen(searchUrl) {
        //window.cpiBreadCrumbs.deleteLastNode();
        //pageHelper.showSearchScreen(searchUrl);
        if (window.cpiBreadCrumbs.getNodes().length > 1)
            window.cpiBreadCrumbs.showPreviousNode();
        else
            pageHelper.openLink(searchUrl, true);

    }

    afterCancelledInsert(id) {
        kendo.destroy(this.infoContainer);
        pageHelper.getDetails(this, id);
    }

    updateRecordStamps() {
        pageHelper.updateRecordStamps(this);
    }
    
    deleteGridRow(e, grid) {
        const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        this.addMoreKeyFields(dataItem);
        
        const self = this;
        pageHelper.deleteGridRow(e, dataItem, function () { self.updateRecordStamps(); });
    }

    emailGridRow(e, grid) {
        const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));

        pageHelper.emailGridRow(e, dataItem, function () { });
    }

    //override to add more key fields
    addMoreKeyFields = (dataItem) => {
    }

    //disable grid editing if main form is dirty or if row is readonly
    isGridColumnEditable = (data) => {
        var readOnly = data.ReadOnly === undefined ? false : data.ReadOnly;
        return !readOnly && !$(`#${this.detailContentContainer}`).hasClass("dirty");
    }

    //add read-only class if row is readonly
    setGridReadOnlyRow = function (e) {
        var gridId = e.sender.element[0].id;
        var grid = $("#" + gridId).data("kendoGrid");
        var data = grid.dataSource.view();

        for (var i = 0; i < data.length; i++) {
            if (data[i].ReadOnly) {
                grid.tbody.find("tr[data-uid='" + data[i].uid + "']").addClass("read-only");
            }
        }
    }

    //sortable grid
    onGridReorder = function (e, url) {
        var gridId = e.sender.element[0].id;
        var grid = $("#" + gridId).data("kendoGrid");
        var dataItem = grid.dataSource.getByUid(e.item.data("uid"));
        var idField = grid.dataSource.reader.model.idField;

        var id = dataItem[idField];
        var newIndex = e.newIndex;

        var self = this;

        cpiLoadingSpinner.show();
        $.ajax({
            type: 'POST',
            url: url,
            dataType: 'json',
            data: {
                id: id,
                newIndex: newIndex
            },
            success: function (result) {
                cpiLoadingSpinner.hide();
                pageHelper.showSuccess(result.success);

                grid.dataSource.read();
                grid.refresh();

                self.updateRecordStamps();
            },
            error: function (e) {
                cpiLoadingSpinner.hide();
                pageHelper.showErrors(e);

                grid.dataSource.read();
                grid.refresh();
            }
        });
    }

    isEditableGridRegistered(name) {
        const pos = this.editableGrids.findIndex(function (el) {
            return el.name === name;
        });
        return pos > -1;
    }

    addEditableGrid(grid) {
        this.editableGrids.push(grid);
    }

   //refreshes the current grid display, useful when you navigate back to search result from detail screen
    refreshSearchResultGrid() {
        const data = pageHelper.getFormCriteria();
        const grid = this.searchResultGrid.data("kendoGrid");
        grid.dataSource.read(data);
    }

    //get next step in multiple step record insert
   getNextStep(id, options) {
        var activePage = this;
        var detailUrl = activePage.detailUrl;
        activePage.currentRecordId = id;
        activePage.detailUrl = `${options.url}/${id}?step=${options.step}`;

       pageHelper.showDetails(activePage, id).then(function () {
           activePage.detailUrl = detailUrl;
        });
   }

    //finish button handler in multiple step record insert
    doneAdding(id) {
        pageHelper.afterInsert(this, id);
    }

    afterInsert(id, options) {
        if (options.url && this.searchContainer && this.searchContainer) { //when Add was triggered from search screen's New button
            //new layout: temporary move breadcrumbs to search screen
            pageHelper.moveBreadcrumbs(this.searchContainer);
            pageHelper.openLink(options.url.replace("recid", id), true, this.searchUrl + "/search");
        }
        else
            pageHelper.afterInsert(this, id);  //refresh detail display, update the record navigator 
    }

    kendoGridDeleteRecord = (e, grid) => {
        var dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        const self = this;
        pageHelper.kendoGridDeleteRecord(e, dataItem, function () { self.updateRecordStamps(); });
    }

    isDirty() {
        return $(`#${this.detailContentContainer}`).hasClass("dirty");
    }

    getElement = (name) => {
        const selector = "input[name=" + name + "]";
        const el = $("#" + this.detailContentContainer).find(selector);
        return el;
    }

    getKendoComboBox = (name) => {
        const selector = "input[name=" + name + "]";
        const el = $("#" + this.detailContentContainer).find(selector);
        const comboBox = el.data('kendoComboBox');
        return comboBox;
    }

    //call using PageViewModel.BeforeSubmit when adding new record to prompt for
    //required entity filter for multiple owners, inventors, or attorneys (gm).
    requiredEntityFilter = (callback) => {
        var entityFilter = $(`#${this.detailContentContainer}`).find("#RequiredEntities");
        var formUrl = entityFilter.data("form-url");
        var errorMesage = entityFilter.data("val-required");

        if (formUrl !== undefined) {
            cpiLoadingSpinner.show();
            $.get(formUrl)
                .done(function (result) {
                    cpiLoadingSpinner.hide();

                    var content = `<form id="RequiredEntityFilterList"><div class="form-group float-label"><label class='required'>${entityFilter.data("label")}</label>${result}<span class="error-message field-validation-error" style="display: none;">${errorMesage}</span></div></form>`;

                    cpiConfirm.save(window.cpiBreadCrumbs.getTitle(), content, function () {
                        var form = $("#RequiredEntityFilterList");
                        var list = form.find("#EntityFilter").data("kendoMultiSelect");

                        if (list.value().length > 0) {
                            entityFilter.val(list.value().join());
                            callback();
                        }
                        else {
                            pageHelper.validateRequiredEntityFilterList();
                            throw errorMesage; //keep confirm dialog open
                        }
                    });
                })
                .fail(function (e) {
                    cpiLoadingSpinner.hide();
                    cpiStatusMessage.error(errorMesage);
                });
        }
        else {
            cpiStatusMessage.error("Unhandled error.");
        }
    };

    showLetterScreen(e, grid) {
        const form = $("#" + this.detailContentContainer).find("form");
        const url = form.data("duedate-letter-url");
        const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        const ddId = dataItem.DDId;
        const actId = dataItem.ActId;

        $.ajax({
            url: url,
            data: { actId: actId, ddId: ddId },
            success: function (result) {
                var popupContainer = $(".cpiContainerPopup").last();
                popupContainer.html(result);
                //var dialog = $("#letterGenDialog");       // this is already on the result view's document ready code
                //dialog.modal("show");
            },
            error: function (e) {
                pageHelper.showErrors(e);
            }
        });
    }

    showEmailScreen(e, grid) {
        const form = $("#" + this.detailContentContainer).find("form");
        const url = form.data("duedate-email-url");
        const dataItem = grid.dataItem($(e.currentTarget).closest("tr"));
        const ddId = dataItem.DDId;

        $.ajax({
            url: url,
            data: {ddId: ddId },
            success: function (result) {
                var popupContainer = $(".cpiContainerPopup").last();
                popupContainer.html(result);
            },
            error: function (e) {
                pageHelper.showErrors(e);
            }
        });
    }

    showCopyScreen() {
        //const popupContainer = $(".cpiContainerPopup").last();
        const popupContainer = $(".site-content .popup").last();
        const dialogContainer = popupContainer.find(".modal");
        let entryForm = dialogContainer.find("form")[0];
        dialogContainer.modal("show");
        
        entryForm = $(entryForm);
        const afterSubmit = (result) => {
            const dataContainer = $(`#${this.mainDetailContainer}`).find(".cpiDataContainer");
            if (dataContainer.length > 0) {
                setTimeout(function () {
                    dataContainer.empty();
                    dataContainer.html(result);
                }, 1000);
            }
        };
        entryForm.cpiPopupEntryForm({ dialogContainer: dialogContainer, afterSubmit: afterSubmit, showSuccessMsg: false });
    }

    markDirty = () => {
        $(this.entryFormInstance).trigger('markDirty');
    }
}
